var appearStoreId = function appearStoreId(id, value) {
  return "".concat(id, ": ").concat(value);
};
export { appearStoreId };